<template>
  <div class="card card-campaign" @click="openCampaign(campaign)">
    <div class="card-body">
      <b-row class="align-items-center">
        <b-col cols="7">
          <h5>{{ campaign.name }}</h5>
          <p style="margin: 15px 0 45px 0">
            {{ formatDate(campaign.start_date) }} à
            {{ formatDate(campaign.end_date) }}
          </p>
          <button 
            type="button" 
            class="btn btn-primary waves-effect waves-float waves-light"
            @click.stop="openCampaign(campaign)"
          >
            Ver detalhes
          </button>
        </b-col>
        <b-col cols="auto">
          <img 
            :src="campaign.image" 
            :alt="campaign.name" 
            height="150" 
            width="150" 
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import useAppConfig from "@core/app-config/useAppConfig";

export default {
  components: {
    BRow,
    BCol,
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { skin } = useAppConfig();
    return { skin };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    openCampaign(campaign) {
      this.$swal({
        backdrop: true,
        title: `${campaign.name}`,
        html: `
          <div style="text-align: center;">
            <img
              src="${campaign.image}"
              alt="Banner da Campanha"
              style="width: 100%; max-height: 200px; object-fit: contain; margin-bottom: 20px;"
            />
            <p>${campaign.details}</p>
             <a
              href="${campaign.link}"
              target="_blank"
              style="
                display: inline-flex;
                align-items: center;
                color: #f26237;
                padding: 10px 15px;
                text-decoration: none;
                font-size: 14px;
                font-weight: 600;
              ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
                style="margin-right: 5px;">
                <path d="M6.354 5.5H2.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V6.207l-5.646 5.647a.5.5 0 0 1-.708-.708L6.354 5.5zm6.5-4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V2.707L7.207 8.854a.5.5 0 0 1-.708-.708L11.293 2H8.5a.5.5 0 0 1 0-1h4z"/>
              </svg>
              Ver regulamento
            </a>
          </div>
        `,
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: "40vw",
        heightAuto: false,
        background: `${this.skin === "dark" ? "#283046" : ""}`,
        customClass: {
          popup: "modal-height",
          confirmButton: "btn btn-primary",
          title: "text-primary",
          htmlContainer: `info-responsive ${this.skin === "dark" ? "text-white" : ""}`,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.swal-wide {
  width: 600px !important;
}
</style>
